import GrayHeaderCard from "../../../../../../../../ui/cards/gray-header-card/GrayHeaderCard";
import Grid from "@material-ui/core/Grid";
import {Button, FormControl, InputLabel} from "@material-ui/core";
import Input from "@material-ui/core/Input/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import {FilterList, Search} from "@material-ui/icons";
import Typography from "@material-ui/core/Typography";
import InlineRadioButtons
    from "../../../../../../../../ui/inputs/radio-buttons/inline-radio-buttons/InlineRadioButtons";
import React, {useState} from "react";
import {useServiziDetailsFilterStyles} from "./ServiziDetailsFilterStyles";
import {serviziFilterRadioButtons} from "./ServiziDetailsFilterHelper";
import PropTypes from "prop-types";
import ServiziDetailsFilterDialog from "./servizi-details-filter-dialog/ServiziDetailsFilterDialog";

const ServiziDetailsFilter = (props) => {
    const classes = useServiziDetailsFilterStyles();
    const [searchText, setSearchText] = useState("")
    const [selectedRadioBtn, setSelectedRadioBtn] = useState(serviziFilterRadioButtons[0].value)
    const [filterDialogOpen, setFilterDialogOpen] = useState(false);

    const handleInputChange = (e) => {
        setSearchText(e.target.value)
    }

    const handleEnterPressed = (e) => {
        if (e.which === 13)
            handleSearchIcon()
    }

    const handleSearchIcon = () => {
        if (searchText.length !== 0) {
            props.handleFilterSearch(selectedRadioBtn, searchText)
            setSearchText("");
        }
    }

    const handleRadioBtnChange = (e) => {
        setSelectedRadioBtn(e.target.value)
    }

    const handleFiltriClick = () => {
        setFilterDialogOpen(true);
    }

    return (
        <>
            <GrayHeaderCard title={<Typography variant={"subtitle1"}>Ricerca</Typography>}
                            height={"thin"}>
                <Grid container
                      justifyContent="space-between"
                      alignItems="center">
                    <Grid item container
                          alignItems="center"
                          xs={12} sm={8} md={9}>
                        <FormControl fullWidth>
                            <InputLabel>Cerca SIM</InputLabel>
                            <Input labelid="filterSearchLabel"
                                   type="search"
                                   autoComplete="off"
                                   onChange={handleInputChange}
                                   value={searchText}
                                   onKeyPress={handleEnterPressed}
                                   endAdornment={
                                       <InputAdornment position="end">
                                           <IconButton onClick={handleSearchIcon}>
                                               <Search/>
                                           </IconButton>
                                       </InputAdornment>
                                   }/>
                        </FormControl>

                        <Typography variant="subtitle2"
                                    display="inline"
                                    color="textSecondary"
                                    className={classes.radioButtons}>
                            Cerca per
                        </Typography>

                        <InlineRadioButtons value={selectedRadioBtn}
                                            radioButtons={serviziFilterRadioButtons}
                                            handleChange={handleRadioBtnChange}/>
                    </Grid>

                    <Grid item container
                          justifyContent="flex-end"
                          xs={12} sm={4} md={3}>
                        <Button variant="outlined"
                                color="primary"
                                startIcon={<FilterList/>}
                                onClick={handleFiltriClick}>
                            Filtra
                        </Button>
                    </Grid>
                </Grid>
            </GrayHeaderCard>
            {filterDialogOpen ?
                <ServiziDetailsFilterDialog
                    filter={props.filter}
                    open={filterDialogOpen}
                    handleDialogClose={() => setFilterDialogOpen(false)}
                    handleFilterSearch={props.handleSelectSearch}/> : null}
        </>
    )
};

ServiziDetailsFilter.propTypes = {
    handleFilterSearch: PropTypes.func.isRequired
}

export default ServiziDetailsFilter;